import { Assessment } from './assessment'
import { CurricularUnits } from './curricularUnits'
import { CoordinatorHome } from './home'
import { lms } from './lms'
import { Offerings } from './offerings'
import { OfferingStudents } from './offeringStudents'
import { Students } from './students'
import { Users } from './users'

export default {
  CoordinatorHome,
  Users,
  Offerings,
  OfferingStudents,
  Students,
  lms,
  Assessment,
  CurricularUnits,
}
